import {Box, Container, Typography} from "@mui/material";
import {Helmet} from "react-helmet";
import {Link} from "react-router-dom";

const NotFound = () => {
    return (
        <>
            <style jsx global>{`
                  html,body, #root, main {
                    height: 100%;
                    margin: 0;
                    overflow: hidden;
                  }
            `}</style>
            <Helmet>
                <title>۴۰۴ - میلفا</title>
                </Helmet>
            <Box sx={{ width: 1, height: 1 }}>
                <Container sx={{height: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                    <Box component="img" src="/assets/image/icon/404.svg" sx={{ width: {xs: 256, lg: 512}, height: {xs: 256, lg: 512}, objectFit: "contain" }}/>
                    <h1 style={{ opacity: 0, position: "fixed" }}>404 Not Found</h1>
                    <Typography variant="h1" component="p" fontSize={{ xs: "1.1rem", lg: "1.25rem" }} fontWeight={700}>خطای 404</Typography>
                    <Typography mt={1.5} fontSize={{xs: ".985rem", lg: "1rem"}} fontWeight={500}>متاسفانه صفحه مورد نظر پیدا نشد!</Typography>
                    <Link to="/">
                        <Typography mt={1.5} fontSize=".975rem" color="primary">بازگشت به صفحه اصلی</Typography>
                    </Link>
                </Container>
            </Box>
        </>
    )
}
export default NotFound;